import React from 'react';
import PropTypes from 'prop-types'
import './Button.scss';

export const Button = (props) => {
  Button.propTypes = {
    type: PropTypes.string,
    action: PropTypes.func,
    title: PropTypes.string.isRequired,
    additionalClass: PropTypes.string,
  };

  const { type, action, title, additionalClass } = props;

  return (
    <div className="button__container">
      <button type={type || 'button'} onClick={event => action ? action(event) : ''} className={`button ${additionalClass && additionalClass}`}>{title}</button>
    </div>
  );
};


// WEBPACK FOOTER //
// ./src/elements/Button/Button.js